var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 151.462 197.405"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.75 0L0 75.75v121.655h7V78.649L75.75 9.9l68.712 68.712v111.793h-30v-88.622H44.8v95.622h106.662V75.712zm31.712 190.405H51.8v-81.622h55.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.577 112.811h-48v23.931h48zm-7 16.931h-34v-9.931h34zM83.077 185.9h20.5v-46.158h-48V185.9h27.5zm0-7v-12.58h13.5v12.58zm13.5-32.161v12.581h-13.5v-12.578zm-20.5 0v12.581h-13.5v-12.578zm-13.5 32.161v-12.58h13.5v12.58z"
  }))));
}

export default SvgLogo;